"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarCard2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
// quote, then avatar image
var AvatarCard2 = function (_a) {
    var image = _a.image, name = _a.name, title = _a.title, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "card h-100 text-center border" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "p-7" }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: "opacity-100 lh-1-75 mb-5" }, { children: ["\u201C", children, "\u201D"] })), (0, jsx_runtime_1.jsx)(_1.AvatarNameTitle, { image: image, name: name, title: title })] })) })));
};
exports.AvatarCard2 = AvatarCard2;
